export default '/build/709358af.svg'